<template>
    <div class="information-wrapper content-wrapper">
        <el-collapse v-model="headerActiveName" accordion>
            <el-collapse-item name="headerInfo">
                <template slot="title">
                    <div class="header-title">
                        <span class="header-title-block"></span>
                        <span class="header-title-txt">时间信息
                            <el-tooltip class="item" effect="dark" content="点击跳转查看任务详情" placement="top">
                                <span class="header-title-jump" @click="openOrderCenter">{{  `( 任务单号： ${ taskNo } )` }}</span>
                            </el-tooltip>
                        </span>
                    </div>
                </template>
                <el-divider></el-divider>
                <el-form style="margin: 10px 0;" label-width="130px" label-position="left">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="下单时间：">
                                <span @dblclick="copyItem($event)">{{formData.orderTime || '--'}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="上游下单时间：">
                                <span @dblclick="copyItem($event)">{{formData.upperOrderTime || '--'}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="预约时间：">
                                <span @dblclick="copyItem($event)">{{formData.appointmentTime || '--'}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="要求发车时间：">
                                <span @dblclick="copyItem($event)">{{formData.requireDepartTime || '--'}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="要求抵达时间：">
                                <span @dblclick="copyItem($event)">{{formData.requireArriveTime || '--'}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="期望送达时间：">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="getExpectTime(formData)"
                                    placement="top-start"
                                >
                                    <div class="item-value" @dblclick="copyItem($event)"> {{getExpectTime(formData)}}</div>
                                </el-tooltip>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="要求回单时间：">
                                <span @dblclick="copyItem($event)">{{formData.requestFileDate || '--'}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="要求签收时间：">
                                <span @dblclick="copyItem($event)">{{formData.requestSignDate || '--'}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
import { copyToClip } from '../util.js';
export default {
    name: 'TimeInformation',
    props: {
        formData: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data () {
        return {
            headerActiveName: 'headerInfo',
            taskNo: ''
        };
    },
    computed: {
        // 期望送达时间
        getExpectTime () {
            return function (formData) {
                const { expectArriveStartTime, expectArriveEndTime } = formData;
                return (expectArriveStartTime || expectArriveEndTime)
                    ? `${expectArriveStartTime || '无'} ~ ${expectArriveEndTime || '无'}`
                    : '--';
            };
        }
    },
    activated () {
        this.taskNo = this.$route.query.taskNo;
    },
    methods: {
        copyItem (e) {
            const value = (e.target.innerHTML).trim();
            value !== '--' && copyToClip(value);
        },
        openOrderCenter () {
            this.$router.push({
                path: '/order-manage/task-detail',
                query: { taskNo: this.taskNo }
            });
        }
    }
};
</script>
